import { NotificationDefinition } from '../../types'
import { InvoiceEmailFailedHeader } from './InvoiceEmailFailedHeader'
import { InvoiceEmailFailedListItem } from './InvoiceEmailFailedListItem'
import { InvoiceEmailFailedPreview } from './InvoiceEmailFailedPreview'

export const invoiceEmailFailedDefinition: NotificationDefinition = {
  listItemContent: InvoiceEmailFailedListItem,
  previewHeaderContent: InvoiceEmailFailedHeader,
  previewContent: InvoiceEmailFailedPreview
}
